var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 15,
  viewBox: "0 0 16 15",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 -1)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M6.564 2.133c.793-1.454 2.083-1.446 2.872 0l6.128 11.234c.793 1.454.083 2.633-1.557 2.633H1.993C.34 16-.353 14.813.436 13.367z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 5,
  x: 7,
  y: 5.5,
  fill: "#FFF",
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  x: 7,
  y: 12,
  fill: "#FFF",
  rx: 0.5
}))));
export default SvgAlert;